import {useContext, useEffect} from 'react'
import {ModalFooterContext} from './Modal.jsx'

export default function ModalFooter({children}) {
    const ctx = useContext(ModalFooterContext)

    useEffect(() => {
        if (!ctx) return
        ctx.setFooter(children)
        return () => ctx.setFooter(null)
    }, [ctx, children])

    if (ctx) return null
    return <>{children}</>
}
